import styled from "styled-components";

export const PollContainer = styled.div`
  position: fixed;
  top: 0%;
  left: 0%;
  height: 100vh;
  width: 100vw;
  z-index: 10;
  backdrop-filter: blur(4px);
  transition: all 0.3s ease-in;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.5);

  &.active {
    visibility: visible;
    opacity: 1;
    pointer-events: all;
  }

  .modal {
    top: 25%;
    left: 50%;
    transform: translateX(-50%);
    background-color: white;
  }
`;

export const GraphContainer = styled.div`
  .recharts-legend-item-text {
    display: none;
  }

  /* .recharts-surface {
  display: none;
} */
`;
